exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".progress-container[data-v-09bca6b8]{margin:10px 20px}#upload-progress[data-v-09bca6b8]{height:20px;border-radius:5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Software/SoftwareRequirements.vue"],"names":[],"mappings":"AACA,qCACI,gBAAkB,CACrB,AACD,kCACI,YAAa,AACb,iBAAmB,CACtB","file":"SoftwareRequirements.vue","sourcesContent":["\n.progress-container[data-v-09bca6b8] {\n    margin: 10px 20px;\n}\n#upload-progress[data-v-09bca6b8] {\n    height: 20px;\n    border-radius: 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09bca6b8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Software/SoftwareRequirements.vue
// module id = 2364
// module chunks = 14